import React from "react";
import { Outlet } from "react-router-dom";
import NavBar from "../app/NavBar";

export default function Root() {
  return (
    <>
      <NavBar />
      <div id="detail">
        <Outlet />
      </div>
    </>
  );
}
